import React from 'react'
import Head from 'next/head'

import Layout from 'app/GNNPage/components/Layout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import SumberBelajarPage from 'app/GNNPage/pages/SumberBelajar'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: ['gnn-page-enabled'],
  async serverProps(_, toggle) {
    if (!toggle?.['gnn-page-enabled']) {
      return {
        notFound: true,
      }
    }
  },
})

const GNNSumberBelajarPage = () => {
  return (
    <>
      <Head>
        <title>Sumber Belajar - Gerakan Numerasi Nasional</title>
      </Head>
      <SumberBelajarPage />
    </>
  )
}

GNNSumberBelajarPage.Layout = Layout

export default GNNSumberBelajarPage
